/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const staticCss = ({ color }) => css`
  align-items: center;
  border-top: 1px solid ${color.border};
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  > * + * {
    margin-left: 8px;
  }
`;

export const CardFooter = ({ children, ...rest }) => (
  <footer {...rest} css={staticCss}>
    {children}
  </footer>
);

CardFooter.propTypes = {
  children: PropTypes.node.isRequired,
};
